import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/img/chevron_left.svg'
import _imports_1 from '@/img/chevron_right.svg'
import _imports_2 from '@/img/in_attesa.svg'
import _imports_3 from '@/img/alarm.svg'
import _imports_4 from '@/img/bell.svg'
import _imports_5 from '@/img/folder.svg'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "boxTitle" }
const _hoisted_4 = { class: "monthNavigator" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "center" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { class: "roundContainer" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "roundItem rosa" }
const _hoisted_16 = { class: "top" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_18 = { class: "itemLabel" }
const _hoisted_19 = { class: "bottom" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "roundItem orange" }
const _hoisted_22 = { class: "top" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_24 = { class: "itemLabel" }
const _hoisted_25 = { class: "bottom" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = { class: "roundItem blue" }
const _hoisted_28 = { class: "top" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_30 = { class: "itemLabel" }
const _hoisted_31 = { class: "bottom" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_33 = { class: "roundList" }
const _hoisted_34 = { class: "left" }
const _hoisted_35 = { class: "title" }
const _hoisted_36 = { class: "label label-viola" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "icon viola" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1)
const _hoisted_38 = { class: "right" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "icon rosa" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "icon orange" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "icon blue" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_45 = { class: "d-flex justify-content-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Overview settimana",
          text: "Overview settimana"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-hollow",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevWeek && _ctx.prevWeek(...args)))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$filters.date(_ctx.fromDate, 'ddd DD/MM')) + " - " + _toDisplayString(_ctx.$filters.date(_ctx.toDate, 'ddd DD/MM')), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-hollow",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextWeek && _ctx.nextWeek(...args)))
          }, _hoisted_11)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Piani in scadenza",
                        text: "Piani in scadenza"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.inScadenza), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "In attesa",
                        text: "In attesa"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.inAttesa), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Da fare",
                        text: "Da fare"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.daFare), 1)
                ])
              ])
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$filters.date(item.date, 'dddd DD MMMM')), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Totale:",
                          text: "Totale:"
                        }),
                        _createTextVNode(" " + _toDisplayString(item.piani.length + item.daFare.length + item.inAttesa.length), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", {
                      class: "label label-rosa pointer",
                      onClick: ($event: any) => (_ctx.openRiepilogo(item.date))
                    }, [
                      _hoisted_40,
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "In scadenza:",
                          text: "In scadenza:"
                        }),
                        _createTextVNode(" " + _toDisplayString(item.piani.length), 1)
                      ])
                    ], 8, _hoisted_39),
                    _createElementVNode("div", {
                      class: "label label-orange pointer",
                      onClick: ($event: any) => (_ctx.openRiepilogo(item.date))
                    }, [
                      _hoisted_42,
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "In attesa:",
                          text: "In attesa:"
                        }),
                        _createTextVNode(" " + _toDisplayString(item.inAttesa.length), 1)
                      ])
                    ], 8, _hoisted_41),
                    _createElementVNode("div", {
                      class: "label label-blue pointer",
                      onClick: ($event: any) => (_ctx.openRiepilogo(item.date))
                    }, [
                      _hoisted_44,
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Da fare:",
                          text: "Da fare:"
                        }),
                        _createTextVNode(" " + _toDisplayString(item.daFare.length), 1)
                      ])
                    ], 8, _hoisted_43)
                  ])
                ]))
              }), 128))
            ])
          ], 64)),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link text-bold",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/lead/calendar')))
        }, [
          _createElementVNode("u", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Mostra calendario",
              text: "Mostra calendario"
            })
          ])
        ])
      ])
    ])
  ]))
}